export enum SortClients {
  Name = 'last_name',
  FirstName = 'first_name',
  LastVisit = '-last_visit',
}
